import {fetchTeamLeave, teamsQueryOptions} from '@blesk-frontend/api';
import {useBleskAuth} from '@blesk-frontend/auth';
import {
  Button,
  ModalConfirm,
  ModalProps,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  useModal,
} from '@blesk-frontend/ui';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useMemo} from 'react';
import {toast} from 'sonner';

export const TeamsTable = () => {
  const queryClient = useQueryClient();
  const {data: teams} = useQuery(teamsQueryOptions());
  const {
    query: {data: user},
  } = useBleskAuth();

  const onClickTeamLeave = useModal<ModalProps & {teamId: string}>((props) => (
    <ModalConfirm
      {...props}
      title="Покинуть команды"
      message="Подтвердите, что вы точно хотите покинуть команду."
      labels={{cancel: 'Отменить', confirm: 'Покинуть'}}
      onConfirm={async () => {
        await fetchTeamLeave(props.teamId);
        queryClient.invalidateQueries({queryKey: teamsQueryOptions().queryKey});
        toast.success('Вы покинули команду');
      }}
    />
  ));

  const joinedTeams = useMemo(
    () =>
      teams?.filter((team) =>
        team.members.some((member) => member.role !== 'owner' && member.userId === user?.id),
      ),
    [teams, user],
  );

  if (!joinedTeams?.length) {
    return null;
  }

  return (
    <>
      <div className="h-px w-full bg-border-primary" />
      <Table>
        <TableHeader>
          <TableRow className="text-text-disabled">
            <TableHead>Доступные команды</TableHead>
            <TableHead className="w-1/12" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {joinedTeams?.map((team) => (
            <TableRow key={`settings-team-${team.id}`}>
              <TableCell>{team.name}</TableCell>
              <TableCell>
                <Button
                  onClick={async () => {
                    onClickTeamLeave({teamId: team.id});
                  }}
                  variant="link"
                  size="icon"
                  className="h-fit w-fit"
                >
                  Покинуть
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
